import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lx-error-message',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss'],
})
export class ErrorMessageComponent {}
